var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},_vm._l((_vm.MENU),function(value,name){return _c('lbz-list',{key:name,attrs:{"subheader":name}},_vm._l((value),function(item,index){return _c('lbz-list-item',{key:index},[_vm._v(_vm._s(item))])}),1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }